/* ============================================================
   Long Run Co. — UNIFIED SUBSCRIPTION block renderer (cleanup)
   One [data-lrc-mp-subscription] root (class "sub" → reuses
   assets/lrc-mp-subscription.css). Reads LRCMP_SUBS / LRCMP_DATA,
   opens engine modals via LRCMP.open*, writes via /apps/lrc.
   Merchant-facing COPY (kept) comes from data-c-*; incidental
   micro-copy is hardcoded. Colors/sizes are brand tokens in CSS.
   ============================================================ */
(function () {
  "use strict";
  var root = document.querySelector("[data-lrc-mp-subscription]");
  if (!root) return;

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function num(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }
  function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
  function cap(s) { s = String(s || "").toLowerCase(); return s.charAt(0).toUpperCase() + s.slice(1); }
  function normId(v) { return ("" + (v == null ? "" : v)).replace(/\D/g, ""); }
  function pick(o, paths, d) {
    for (var i = 0; i < paths.length; i++) { var c = o, ok = true, p = paths[i].split(".");
      for (var j = 0; j < p.length; j++) { if (c != null && typeof c === "object" && p[j] in c) c = c[p[j]]; else { ok = false; break; } }
      if (ok && c != null && c !== "") return c; } return d;
  }
  function toArray(x) { if (Array.isArray(x)) return x; if (x == null) return []; if (typeof x === "object") { var k = ["contracts","content","data","items","nodes"]; for (var i = 0; i < k.length; i++) if (Array.isArray(x[k[i]])) return x[k[i]]; return [x]; } return []; }
  function moneyVal(m) { if (m == null) return null; if (typeof m === "number") return m; if (typeof m === "string") return num(m); if (typeof m === "object") { if (m.amount != null) return moneyVal(m.amount); if (m.value != null) return moneyVal(m.value); } return null; }
  function currencyOf(m, fb) { if (m && typeof m === "object") { if (m.currencyCode) return m.currencyCode; if (m.amount && m.amount.currencyCode) return m.amount.currencyCode; } return fb || "USD"; }
  function fmtMoney(a, c) { if (a == null) return null; try { return new Intl.NumberFormat(undefined, { style: "currency", currency: c || "USD" }).format(a); } catch (e) { return "$" + Number(a).toFixed(2); } }
  var DOWF = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  var MONF = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  var MON = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  function parseDate(v) { if (!v) return null; var d = new Date(v); return isNaN(d.getTime()) ? null : d; }
  function fmtDateFull(v) { var d = parseDate(v); if (!d) return null; return DOWF[d.getDay()] + ", " + MONF[d.getMonth()] + " " + d.getDate(); }
  function fmtDateShort(v) { var d = parseDate(v); if (!d) return null; return MON[d.getMonth()] + " " + d.getDate(); }
  function fmtDateMDY(v) { var d = parseDate(v); if (!d) return null; return MON[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear(); }
  function addDays(v, n) { var d = parseDate(v); if (!d) return null; var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  var UNIT_DAYS = { day: 1, week: 7, month: 30, year: 365 };
  function intervalDays(interval, count) { if (!interval) return null; var u = String(interval).toLowerCase().replace(/s$/, ""); if (!UNIT_DAYS[u]) return null; return (num(count) || 1) * UNIT_DAYS[u]; }
  function intervalLabel(interval, count) { if (!interval) return null; var u = String(interval).toLowerCase().replace(/s$/, ""), n = num(count) || 1; var pl = { day: "days", week: "weeks", month: "months", year: "years" }[u] || (u + "s"); return n === 1 ? ("Every " + u) : ("Every " + n + " " + pl); }
  function fmtAddressShort(a) { if (!a) return null; var city = pick(a, ["city"], ""), prov = pick(a, ["provinceCode", "province"], ""); if (city && prov) return city + ", " + prov; return pick(a, ["formattedArea", "city", "address1"], null); }
  function paymentLabel(p) { var brand = pick(p, ["cardBrand"], ""), last4 = pick(p, ["cardLastDigits"], ""); if (brand || last4) return (cap(brand) + (last4 ? " ··" + last4 : "")).trim(); return pick(p, ["instrumentType"], null); }
  function srow(label, val, cls) { return '<div class="srow"><span>' + esc(label) + "</span><span" + (cls ? ' class="' + cls + '"' : "") + ">" + val + "</span></div>"; }

  /* Prepaid contracts charge once per billing cycle but ship multiple times within it (e.g. billed every 360
     days, delivered every 90 → 4 deliveries/charge). currentPrice is then per-BILLING, not per-unit, so divide
     by this ratio to get the per-shipment unit price. PAYG returns 1 (billing == delivery) → no behavior change.
     Requires same interval unit on both policies; otherwise the ratio isn't a clean integer and we keep 1. */
  function deliveriesPerBilling(c, dto) {
    var bI = String(pick(c, ["billingPolicy.interval"], null) || pick(dto, ["billingPolicyInterval"], "") || "").toUpperCase();
    var dI = String(pick(c, ["deliveryPolicy.interval"], null) || pick(dto, ["deliveryPolicyInterval"], "") || "").toUpperCase();
    var bC = num(pick(c, ["billingPolicy.intervalCount"], null) || pick(dto, ["billingPolicyIntervalCount"], null));
    var dC = num(pick(c, ["deliveryPolicy.intervalCount"], null) || pick(dto, ["deliveryPolicyIntervalCount"], null));
    if (bI && dI && bI === dI && bC > 0 && dC > 0 && bC > dC) return Math.round(bC / dC);
    return 1;
  }

  /* Locked-cadence popover (Stash plans). forceState: true=open, false=close, undefined=toggle. */
  function toggleCadenceLocked(forceState) {
    var p = root.querySelector("[data-cadence-locked]"); if (!p) return;
    var willOpen = (forceState === true) ? true : (forceState === false ? false : !!p.hidden);
    if (willOpen) { var dlink = root.querySelector("[data-cadence-dlink]"); if (dlink) p.style.top = (dlink.offsetTop + dlink.offsetHeight + 6) + "px"; }
    p.hidden = !willOpen;
  }

  var PENCIL = '<svg viewBox="0 0 16 16" width="100%" height="100%" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5 2.2l2.3 2.3L6 12.3l-3 .7 .7-3 7.8-7.8z"/></svg>';

  function subsContracts() { var s = window.LRCMP_SUBS; return s ? toArray(s.contracts).filter(Boolean) : []; }
  function activeIndex() { var v = window.LRCMP_SUB_ACTIVE; return (v == null) ? 0 : v; }
  function setActiveShared(i) { window.LRCMP_SUB_ACTIVE = i; try { document.dispatchEvent(new CustomEvent("lrc-mp:sub-active", { detail: { index: i } })); } catch (e) {} }
  function statusOf(b) { return String(((b && b.dto) || {}).status || "").toLowerCase(); }
  function contractIdAt(i) { var b = subsContracts()[i]; var d = (b && b.dto) || b || {}; return String(d.subscriptionContractId || d.contractId || d.id || ""); }
  function identity() { return window.LRCMP_DATA || {}; }

  var DESIGN = root.getAttribute("data-design-mode") === "true" || (typeof window.Shopify !== "undefined" && window.Shopify && window.Shopify.designMode === true);
  var FREE_SHIP = num(root.getAttribute("data-free-ship-threshold")); if (FREE_SHIP == null) FREE_SHIP = 49;
  var FREE_SHIP_CODES = (root.getAttribute("data-free-ship-codes") || "")
    .split(",").map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  var TRANSIT = num(root.getAttribute("data-transit-days")); if (TRANSIT == null) TRANSIT = 5;
  /* True prepaid Stash plans only (6mo + 12mo). NOTE: the Stash modal's "3 month" tier reuses the 25% Tier
     90 Days plan (692168458553), which is PAYG — deliberately EXCLUDED so it keeps flexible behavior. */
  var STASH_PLAN_IDS = { "702230561081": 1, "702230593849": 1 };
  function planTail(x) { x = String(x == null ? "" : x); var m = x.match(/(\d+)\s*$/); return m ? m[1] : x; }
  function a(name, d) { var v = root.getAttribute("data-c-" + name); return (v != null && v !== "") ? v : d; }   /* KEPT copy */
  var C = {
    /* kept (merchant-configurable) */
    headlineTemplate: a("headline-template", "{date}"), subhead: a("subhead-template", "{interval} more days of fuel ships {date}"),
    savings: a("savings-template", "You're saving {pct}% this order"),
    promoApplying: a("promo-applying-label", "Applying…"),
    promoErrNotFound: a("promo-error-not-found", "We couldn't find that code"),
    promoErrExpired: a("promo-error-expired", "This code has expired"),
    promoErrNotApplicable: a("promo-error-not-applicable", "This code doesn't apply to your items"),
    promoErrAlreadyApplied: a("promo-error-already-applied", "This code is already applied"),
    promoErrUnknown: a("promo-error-unknown", "Something went wrong — try again"),
    promoErrNetwork: a("promo-error-network", "Connection issue — try again"),
    promoSuccess: a("promo-success-template", "Applied: {code} – Save ${amount}"),
    addbtn: a("addbtn-label", "+ Add a product to this shipment"), freeLabel: a("free-label", "Free"),
    oneTimeBadge: (function () { var v = root.getAttribute("data-sd-one-time-badge"); return (v != null && v !== "") ? v : "ONE-TIME"; })(),
    memberPriceLabel: (function () { var v = root.getAttribute("data-sd-member-price-label"); return (v != null && v !== "") ? v : "Member price"; })(),
    pSubtotal: a("p-subtotal", "Subtotal"), pMember: a("p-member-savings", "Member savings"), pDiscount: a("p-discount-applied", "Discount applied"),
    pFreeGift: a("p-free-gift", "Free gift"), pShipping: a("p-shipping", "Calculated at fulfillment"), pFreeShip: a("p-free-shipping", "Free shipping"), pTotal: a("p-total", "Total"),
    freeShipProgress: a("free-ship-progress", "You're {diff} away from free shipping on every order"),
    endedEyebrow: a("ended-eyebrow", "Your previous subscription"), endedHeadline: a("ended-headline-template", "Ended {date}"),
    reactivate: a("reactivate-label", "Reactivate subscription"), reactivateSuccess: a("reactivate-success", "Reactivated. Refreshing..."),
    pausedBanner: a("paused-banner-template", "Paused as of {date}"), resume: a("resume-label", "Resume subscription"),
    pausedEyebrow: a("paused-eyebrow", "Paused"),
    pausedHeadline: a("paused-headline-template", "Paused as of {date}"), pausedBubble: a("paused-bubble-text", "Your subscription is temporarily paused."),
    /* hardcoded (incidental micro-copy / formatting) */
    pill: "Subscription", shipsPrefix: "Ships ", headlineFallback: "Your next shipment", sep: " · ", qtySep: "×",
    tlShips: "Ships", tlArrives: "Arrives", tlRunlow: "You run low",
    /* forecast footer fallbacks (cfg copy from window.LRC_FORECAST_CFG.copy wins; no em/en dashes) */
    fcOnTrack: "Arrives before you run low - you're all set.", fcShort: "You'll run low before your next box arrives.",
    fcOver: "You're getting more than you'll use.", fcNew: "Your first box is on the way.",
    fcNoRate: "Take the quiz to see when you'll run low.",
    fcSkip: "Skip this one and your next box won't arrive until {nextNextDelivery}.",
    fcCtaOver: "Adjust what you get", fcCtaQuiz: "Take the quiz",
    sampleBadge: "On us", sampleQty: "qty", sampleThumb: "FREE SAMPLE", shippingRowLabel: "Shipping",
    emptyItems: "No items on this shipment.", freeshipMet: a("freeship-met", "✓ You're getting free shipping on this shipment"), freeshipMetCode: a("freeship-met-code", "✓ You're getting free shipping on every order"),
    badgePaused: "Paused", endedLabel: "Ended", moreLabel: "+{N} more",
    working: "Working...", writeError: "Something went wrong. Nothing was changed. Please try again."
  };
  var ROSTER = (function () { try { return JSON.parse(root.getAttribute("data-sd-quick-add") || "[]"); } catch (e) { return []; } })();
  var showAllEnded = false;
  var EYEBROW0 = (function () { var e = root.querySelector(".eyebrow"); return e ? e.textContent : ""; })();

  function region(name) { return root.querySelector('[data-mp-region="' + name + '"]'); }
  function has(name) { return !!region(name); }
  function setText(name, v) { var el = region(name); if (el) el.textContent = (v == null || v === "") ? "—" : v; }
  function setHTML(name, h) { var el = region(name); if (el) el.innerHTML = h; }
  function show(el) { if (el) el.classList.remove("lrc-mp__hide"); }
  function hide(el) { if (el) el.classList.add("lrc-mp__hide"); }

  function subWrite(payload, btn, errEl, onOk, onErr) {
    if (errEl) errEl.hidden = true;
    if (!payload || !payload.contractId) { if (errEl) { errEl.textContent = C.writeError; errEl.hidden = false; } if (onErr) onErr(); return; }
    if (btn) { if (btn.dataset.prevLabel == null) btn.dataset.prevLabel = btn.textContent; btn.disabled = true; btn.textContent = C.working; }
    fetch("/apps/lrc", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }, function () { return { ok: r.ok, j: null }; }); })
      .then(function (res) { if (res.ok && res.j && res.j.ok) { if (onOk) onOk(); return; } throw new Error("write_failed"); })
      .catch(function () {
        if (btn) { btn.disabled = false; if (btn.dataset.prevLabel != null) { btn.textContent = btn.dataset.prevLabel; delete btn.dataset.prevLabel; } }
        if (errEl) { errEl.textContent = C.writeError; errEl.hidden = false; }
        if (onErr) onErr();
      });
  }

  /* ===================== RENDER ENTRY POINTS ===================== */
  function onData() {
    var contracts = subsContracts();
    if (!contracts.length) { root.hidden = true; return; }
    if (window.LRCMP_SUB_ACTIVE == null) window.LRCMP_SUB_ACTIVE = 0;
    root.hidden = false;
    renderSelector(contracts);
    renderActive(activeIndex());
  }

  function chipHTML(b, i) {
    /* prefer the engine ship date for this contract; fall back to nextBillingDate when the engine isn't ready */
    var f = forecastFor(forecastCidFrom(b.contract || {}, b.dto || {}));
    var shipSrc = (f && f.shipDate) ? f.shipDate : (pick(b.dto, ["nextBillingDate", "nextPaidBillingDate"], null) || pick(b.contract, ["nextBillingDate"], null));
    var date = fmtDateShort(shipSrc);
    var badge = statusOf(b) === "paused" ? '<span class="sbadge sbadge--paused">' + esc(C.badgePaused) + "</span>" : "";
    return '<div class="ctab' + (i === activeIndex() ? " on" : "") + '" data-sub-tab="' + i + '"><div class="ck">' + esc(C.pill) + badge + '</div><div class="cv">' + esc(date ? (C.shipsPrefix + date) : C.pill) + "</div></div>";
  }
  function endedChip(b, i) {
    var date = fmtDateShort(pick(b.dto, ["cancelledOn", "nextBillingDate"], null));
    return '<div class="ctab ctab--ended' + (i === activeIndex() ? " on" : "") + '" data-sub-tab="' + i + '">' + esc(C.endedLabel) + (date ? C.sep + esc(date) : "") + "</div>";
  }
  function renderSelector(contracts) {
    var host = region("contracts"); if (!host) return;
    var subEl = root;   /* section-scoped wrapper; a global ".sub" matches the rewards empty-state <p> earlier in the DOM, landing lrc-no-tabs on the wrong element */
    /* always drop any prior nudge first so it never duplicates or lingers when conditions change */
    (function () { var old = root.querySelector(".combine-nudge"); if (old && old.parentNode) old.parentNode.removeChild(old); })();
    function setRowVisible(visible) {
      if (visible) { show(host); if (subEl) subEl.classList.remove("lrc-no-tabs"); }
      else { hide(host); host.innerHTML = ""; if (subEl) subEl.classList.add("lrc-no-tabs"); }
    }
    var act = activeIndex(), activeIdx = [], endedIdx = [];
    contracts.forEach(function (b, i) { if (statusOf(b) === "cancelled") endedIdx.push(i); else activeIdx.push(i); });

    var html = "", visibleCount = 0;
    if (activeIdx.length >= 1) {
      /* at least one non-cancelled (active/paused) contract: render ONLY those chips; skip every cancelled chip
         (no endedChip, no "+N more"). Existing index/click mapping preserved via the original index i. */
      html = activeIdx.map(function (i) { return chipHTML(contracts[i], i); }).join("");
      visibleCount = activeIdx.length;
    } else {
      /* zero non-cancelled: fall back to rendering cancelled chips exactly as before */
      var shownEnded = showAllEnded ? endedIdx.slice() : endedIdx.slice(0, 2);
      if (endedIdx.indexOf(act) !== -1 && shownEnded.indexOf(act) === -1) shownEnded.push(act);
      var hiddenN = endedIdx.length - shownEnded.length;
      html = shownEnded.map(function (i) { return endedChip(contracts[i], i); }).join("");
      visibleCount = shownEnded.length;
      if (!showAllEnded && hiddenN > 0) html += '<button type="button" class="ctab ctab--more" data-sd-more>' + esc(C.moreLabel.replace(/\{N\}/g, hiddenN)) + "</button>";
    }

    if (visibleCount <= 1) { setRowVisible(false); return; }
    setRowVisible(true);
    host.innerHTML = html;
    Array.prototype.forEach.call(host.querySelectorAll("[data-sub-tab]"), function (el) { el.addEventListener("click", function () { setActiveShared(num(el.getAttribute("data-sub-tab"))); }); });
    var more = host.querySelector("[data-sd-more]"); if (more) more.addEventListener("click", function () { showAllEnded = true; renderSelector(subsContracts()); });

    /* combine-subscriptions link: shown only when 2+ non-cancelled contracts (row is therefore visible). ONE
       single-line mailto link, no lead text, no dismiss. Inserted immediately ABOVE the pill row (any prior
       .combine-nudge was already removed at the top of renderSelector). */
    /* STAGE 1 combine: nudge shows only when 2+ NON-prepaid (PAYG) contracts can merge; clicking opens the
       confirm modal (dry-run only - no writes yet) instead of the old mailto. */
    var paygIdx = activeIdx.filter(function (i) { return !isPrepaidContract(contracts[i]); });
    if (paygIdx.length >= 2 && host.parentNode) {
      var nudge = document.createElement("a");
      nudge.className = "combine-nudge";
      nudge.setAttribute("href", "#");
      nudge.innerHTML = "Want to combine into one delivery?&nbsp;&rarr;";
      nudge.addEventListener("click", function (e) { if (e) e.preventDefault(); openCombine(paygIdx.slice()); });
      host.parentNode.insertBefore(nudge, host);
    }
  }

  /* ===================== STAGE 2: COMBINE SUBSCRIPTIONS (pick the primary survivor + REAL execution) ===================== */
  /* a contract is PREPAID if any line's selling plan (trailing digits) is a Stash plan; merge is PAYG-only for now */
  function isPrepaidContract(bundle) {
    var c = (bundle && bundle.contract) || {};
    var lns = toArray(pick(c, ["lines.nodes", "lines"], []));
    return lns.some(function (ln) { return !!STASH_PLAN_IDS[planTail(pick(ln, ["sellingPlanId"], ""))]; });
  }
  function combineCid(dto) { return String(pick(dto, ["subscriptionContractId", "contractId", "id"], "")); }
  function cadenceDaysOf(dto) {
    var unit = String(pick(dto, ["deliveryPolicyInterval", "billingPolicyInterval"], "") || "").toUpperCase();
    var cnt = num(pick(dto, ["deliveryPolicyIntervalCount", "billingPolicyIntervalCount"], null)) || 0;
    var per = unit === "WEEK" ? 7 : unit === "MONTH" ? 30 : unit === "DAY" ? 1 : 0;
    return (per && cnt) ? per * cnt : null;
  }
  function combineBillMs(v) { var t = v ? new Date(v).getTime() : NaN; return isNaN(t) ? -Infinity : t; }
  function combineModalQ(sel) { var m = document.querySelector('[data-modal="combineModal"]'); return m ? m.querySelector(sel) : null; }

  var combineState = null;

  function openCombine(paygIdx) {
    var contracts = subsContracts();
    var items = paygIdx.map(function (i) {
      var b = contracts[i], dto = (b && b.dto) || {}, c = (b && b.contract) || {};
      return { idx: i, bundle: b, cid: combineCid(dto),
        lines: toArray(pick(c, ["lines.nodes", "lines"], [])),
        cadenceDays: cadenceDaysOf(dto), nextBill: pick(dto, ["nextBillingDate"], null) };
    });
    /* DEFAULT survivor = the LATEST next-billing date (so we never pull a charge forward) */
    var def = items.slice().sort(function (a, b) { return combineBillMs(b.nextBill) - combineBillMs(a.nextBill); })[0];
    combineState = { items: items, selectedCid: def ? def.cid : (items[0] ? items[0].cid : null), working: false };
    combineRenderPrimary();
    combineRenderSummary();
    var err = combineModalQ("[data-cmb-err]"); if (err) { err.hidden = true; err.textContent = ""; }
    var cta = combineModalQ("[data-cmb-cta]");
    if (cta) { cta.disabled = false; cta.textContent = "Combine"; cta.onclick = function () { runCombine(); }; }
    if (window.LRCMP && LRCMP.open) LRCMP.open("combineModal");
  }
  /* survivor = the USER-SELECTED primary contract; sources = all other eligible PAYG contracts */
  function combineSelected() {
    var st = combineState; if (!st || !st.items.length) return null;
    for (var i = 0; i < st.items.length; i++) { if (st.items[i].cid === st.selectedCid) return st.items[i]; }
    return st.items[0];
  }
  function combineSources() {
    var st = combineState; if (!st) return [];
    var sel = combineSelected();
    return st.items.filter(function (it) { return it !== sel; });
  }
  /* one selectable row per eligible PAYG sub (radio behavior); the chosen one gets .is-selected */
  function combineRenderPrimary() {
    var host = combineModalQ("[data-cmb-cadence]"); if (!host) return;
    var st = combineState; if (!st) { host.hidden = true; host.innerHTML = ""; return; }
    host.hidden = false;
    var rows = st.items.map(function (it) {
      var dl = fmtDateShort(it.nextBill), dateStr = dl ? ("Ships " + dl) : "Subscription";
      var cadStr = (it.cadenceDays != null) ? ("Every " + it.cadenceDays + " days") : "";
      var n = (it.lines || []).length, itemsStr = n + (n === 1 ? " item" : " items");
      var meta = [cadStr, itemsStr].filter(Boolean).join(" · ");
      var seld = (it.cid === st.selectedCid);
      return '<div class="cmb-primary-row' + (seld ? " is-selected" : "") + '" data-cmb-primary="' + esc(it.cid) +
        '" role="radio" aria-checked="' + (seld ? "true" : "false") + '" tabindex="0">' +
        '<span class="cmb-radio" aria-hidden="true"></span>' +
        '<span class="cmb-primary-txt"><span class="cmb-primary-date">' + esc(dateStr) + '</span>' +
        '<span class="cmb-primary-meta">' + esc(meta) + '</span></span></div>';
    }).join("");
    host.innerHTML = '<div class="cmb-primary-head">Choose your primary subscription</div><div class="cmb-primary-list" role="radiogroup">' + rows + "</div>";
    Array.prototype.forEach.call(host.querySelectorAll("[data-cmb-primary]"), function (el) {
      function selectRow() { if (combineState && combineState.working) return; combineState.selectedCid = el.getAttribute("data-cmb-primary"); combineRenderPrimary(); combineRenderSummary(); }
      el.addEventListener("click", selectRow);
      el.addEventListener("keydown", function (e) { if (e && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); selectRow(); } });
    });
  }
  function combineRenderSummary() {
    var host = combineModalQ("[data-cmb-summary]"); if (!host) return;
    var st = combineState, sel = combineSelected(); if (!st || !sel) { host.innerHTML = ""; return; }
    var dl = fmtDateShort(sel.nextBill), dateStr = dl ? (dl + " ") : "";
    var nCancel = combineSources().length;
    var others = nCancel + " other" + (nCancel === 1 ? "" : "s");
    var head = "We'll move everything into your " + dateStr + "subscription and cancel the " + others + ".";
    var tail = "Your delivery schedule and next charge date stay the same.";
    host.innerHTML = '<div class="cmb-head">' + esc(head) + "</div>" +
      '<div class="cmb-tail" style="margin-top:8px">' + esc(tail) + "</div>";
  }
  /* REAL EXECUTION: sequential adds onto the survivor (no plan/price params → inherits the survivor's plan),
     verify EVERY add, then sequential cancels of the sources. A failed add stops BEFORE any cancel. */
  function runCombine() {
    var st = combineState; if (!st || st.working) return;
    var survivor = combineSelected(); if (!survivor) return;
    var sources = combineSources();
    var adds = [];
    sources.forEach(function (it) {
      it.lines.forEach(function (ln) {
        var v = pick(ln, ["variantId"], ""), q = num(pick(ln, ["quantity"], 1)) || 1;
        adds.push("/apps/subscriptions/cp/api/v2/subscription-contracts-add-line-item?contractId=" + encodeURIComponent(survivor.cid) +
          "&variantId=" + encodeURIComponent(v) + "&quantity=" + encodeURIComponent(q) + "&isOneTimeProduct=false");
      });
    });
    var cta = combineModalQ("[data-cmb-cta]"), err = combineModalQ("[data-cmb-err]");
    st.working = true;
    if (err) { err.hidden = true; err.textContent = ""; }
    if (cta) { cta.disabled = true; cta.textContent = "Combining…"; }
    function fail(msg) {
      st.working = false;
      if (cta) { cta.disabled = false; cta.textContent = "Combine"; }
      if (err) { err.textContent = msg; err.hidden = false; }
    }
    function reload() { try { location.reload(); } catch (e) {} }
    /* 1) ADDS - strictly sequential; ANY failure aborts before ANY cancel (moved lines are recoverable; a mis-cancel is not) */
    function doAdds(i) {
      if (i >= adds.length) { doCancels(); return; }
      fetch(adds[i], { method: "PUT", credentials: "same-origin", redirect: "manual", headers: { "Accept": "application/json" } })
        .then(function (r) {
          if (!r.ok || r.type === "opaqueredirect" || r.status === 0) throw new Error("add_failed");
          doAdds(i + 1);
        })
        .catch(function () { fail("Something went wrong combining your subscriptions - nothing was changed. Please try again or contact support."); });
    }
    /* 2) CANCELS - only after EVERY add verified; sequential; capture failures so we never silently double-charge */
    function doCancels() {
      var failed = [];
      function cancelOne(i) {
        if (i >= sources.length) { finish(failed); return; }
        var it = sources[i];
        subWrite({ action: "cancel", contractId: it.cid, reason: "merged_into:" + survivor.cid }, null, null,
          function () { cancelOne(i + 1); },
          function () { failed.push(it.cid); cancelOne(i + 1); });
      }
      cancelOne(0);
    }
    function finish(failed) {
      if (failed.length) {
        if (err) { err.textContent = "Your subscriptions were combined, but we couldn't cancel " + failed.length + " of the old ones. Please contact support so we can finish up."; err.hidden = false; }
        setTimeout(reload, 3000);   /* still reload so the merged state shows */
      } else {
        reload();
      }
    }
    doAdds(0);
  }

  function renderActive(i) {
    var contracts = subsContracts(), bundle = contracts[i]; if (!bundle) return;
    var host = region("contracts");
    if (host) Array.prototype.forEach.call(host.querySelectorAll(".ctab"), function (t) { t.classList.toggle("on", num(t.getAttribute("data-sub-tab")) === i); });
    var c = bundle.contract || {}, dto = bundle.dto || {}, st = statusOf(bundle);
    var ended = st === "cancelled", paused = st === "paused", active = !ended && !paused;
    var currency = pick(dto, ["currencyCode"], null) || currencyOf(c.deliveryPrice, "USD");
    var lines = toArray(pick(c, ["lines.nodes", "lines"], []));
    var nextDate = pick(dto, ["nextBillingDate", "nextPaidBillingDate"], null) || pick(c, ["nextBillingDate"], null);

    root.classList.remove("sd-active", "sd-paused", "sd-ended");
    root.classList.add(ended ? "sd-ended" : paused ? "sd-paused" : "sd-active");
    var ey = root.querySelector(".eyebrow");

    /* header */
    if (ended) {
      if (ey) ey.textContent = C.endedEyebrow;
      setText("drop-title", C.endedHeadline.replace("{date}", fmtDateMDY(dto.cancelledOn) || "").trim());
      setText("drop-recap", "");
    } else if (paused) {
      if (ey) ey.textContent = C.pausedEyebrow;
      setText("drop-title", C.pausedHeadline.replace("{date}", fmtDateMDY(pick(dto, ["pausedOn"], null)) || "").trim());
      setText("drop-recap", "");   /* helper turns "" into the dash, mirroring ended */
    } else {
      if (ey) ey.textContent = EYEBROW0;
      /* header hero + subline display the engine ship date when available, else fall back to nextBillingDate */
      var fcA = forecastFor(forecastCidFrom(c, dto));
      var dateStr = fmtDateFull((fcA && fcA.shipDate) ? fcA.shipDate : nextDate);
      setText("drop-title", dateStr ? C.headlineTemplate.replace("{date}", dateStr) : C.headlineFallback);
      if (has("drop-recap")) {
        var di0 = intervalDays(pick(c, ["deliveryPolicy.interval"], null) || pick(dto, ["deliveryPolicyInterval", "billingPolicyInterval"], null), pick(c, ["deliveryPolicy.intervalCount"], null) || pick(dto, ["deliveryPolicyIntervalCount", "billingPolicyIntervalCount"], 1));
        setText("drop-recap", paused ? "" : C.subhead.replace("{interval}", di0 != null ? di0 : "—").replace("{date}", dateStr || "soon"));
      }
    }

    var bn = region("paused-banner");
    if (bn) bn.innerHTML = paused ? pausedBannerHTML(dto) : "";

    if (has("drop-forecast")) { if (active) renderForecast(nextDate, c, dto); else setHTML("drop-forecast", ""); }
    renderPromoState(c, dto);   /* applied-code chips (or link/input) from THIS contract's discounts */
    var dpb = deliveriesPerBilling(c, dto);
    /* Order block restructure: the savings pill + small "+ Add product" are replaced by a single left-aligned
       "YOUR ITEMS" header inside .sd-savings-add (the element is kept so the section divider above it survives;
       only its inner content changes). The pill's percent now rides the MEMBER SAVINGS summary row. Both add
       buttons (data-sd-add small + data-sd-addbtn big) share one handler, so removing the small one is safe. */
    var savePct = 0;
    if (active) { var _sv = lineSavings(lines, readSampleConfig(region("drop-items")), dpb); savePct = (_sv.base > 0) ? Math.round(_sv.save / _sv.base * 100) : 0; }
    /* standalone savings badge inserted immediately AFTER the .recap subtext (same percent); removed when 0 / non-active */
    (function () {
      var oldB = root.querySelector(".sd-savings-badge"); if (oldB && oldB.parentNode) oldB.parentNode.removeChild(oldB);
      var recapEl = region("drop-recap");
      if (recapEl && recapEl.parentNode && savePct > 0) {
        var badge = document.createElement("div");
        badge.className = "sd-savings-badge";
        badge.textContent = "You're saving " + savePct + "% this order";
        recapEl.parentNode.insertBefore(badge, recapEl.nextSibling);
      }
    })();
    var savAddEl = root.querySelector(".sd-savings-add"); if (savAddEl) savAddEl.innerHTML = '<div class="sd-items-head">YOUR ITEMS</div>';
    /* Remember the inputs so the totals can be recomputed in place later without a re-fetch.
       `lines` holds the SAME line objects the in-place edit paths mutate, so re-running the same
       code path against them yields exactly what a hard reload would show. */
    _lastIP = { c: c, dto: dto, lines: lines, currency: currency, dpb: dpb, active: active,
                opt: { active: active, ended: ended, savePct: savePct } };
    renderItemsAndPricing(c, dto, lines, currency, { active: active, ended: ended, savePct: savePct });

    /* Stash (prepaid) detection — 6mo + 12mo plans only; 25% Tier 90 Days (692168458553) is PAYG → excluded. */
    var isOnStashPlan = toArray(lines).some(function (ln) { return !!STASH_PLAN_IDS[planTail(pick(ln, ["sellingPlanId"], ""))]; });
    /* CHANGE 1: hide the Prepay & Save CTA on Stash contracts (empty string reverts to CSS for non-Stash). */
    var prepayCta = root.querySelector("[data-prepay-cta]");
    if (prepayCta) prepayCta.style.display = isOnStashPlan ? "none" : "";

    /* CHANGE 2: the cadence chip stays visually identical (same intervalLabel value + .dlink styling). Only the
       tap target differs — Stash opens a locked panel, PAYG opens the cadence picker. NON-DESTRUCTIVE: value,
       class and onclick are re-set every render so switching between contracts always reflects THIS contract. */
    var cadDlink = root.querySelector("[data-cadence-dlink]");
    if (has("detail-cadence")) {
      if (isOnStashPlan) {
        var cadDi = pick(c, ["deliveryPolicy.interval"], null) || pick(dto, ["deliveryPolicyInterval"], null) || "DAY";
        var cadDc = num(pick(c, ["deliveryPolicy.intervalCount"], null) || pick(dto, ["deliveryPolicyIntervalCount"], null)) || 90;
        setText("detail-cadence", intervalLabel(cadDi, cadDc));   /* delivery cadence (90), not billing (360) */
      } else {
        setText("detail-cadence", intervalLabel(pick(c, ["billingPolicy.interval"], null) || pick(dto, ["billingPolicyInterval"], null), pick(c, ["billingPolicy.intervalCount"], null) || pick(dto, ["billingPolicyIntervalCount"], 1)));
      }
    }
    if (cadDlink) {
      cadDlink.classList.toggle("is-locked", isOnStashPlan);
      cadDlink.onclick = isOnStashPlan
        ? function (e) { if (e) { e.preventDefault(); e.stopPropagation(); } LRCMP.open("cadenceLocked"); }
        : function (e) { if (e) e.preventDefault(); toggleCadenceLocked(false); if (LRCMP.openCadence) LRCMP.openCadence(); };
    }
    if (has("detail-address")) setText("detail-address", fmtAddressShort(pick(c, ["deliveryMethod.address", "deliveryMethod.shippingAddress"], null)));
    if (has("detail-payment")) setText("detail-payment", paymentLabel(bundle.payment || {}));

    /* CTA host (now at TOP, between selector and banner) */
    var cta = region("cta");
    if (cta) {
      if (ended) cta.innerHTML = '<div class="sd-err" data-sd-err hidden></div><button type="button" class="btn sd-cta sd-cta--reactivate" data-sd-reactivate data-reason="ended_block_reactivate">' + esc(C.reactivate) + "</button>";
      else if (paused) cta.innerHTML = '<div class="sd-err" data-sd-err hidden></div><button type="button" class="btn sd-cta sd-cta--resume" data-sd-reactivate data-reason="paused_block_resume">' + esc(C.resume) + "</button>";
      else cta.innerHTML = "";
    }
  }

  function pausedBannerHTML(dto) {
    /* date now lives in the headline (mirroring ended); the bubble is static reassurance copy */
    return '<div class="sd-paused-banner"><span>' + esc(C.pausedBubble) + "</span></div>";
  }

  /* contractId on the bundle (same id get_forecast keys on); exact match then numeric-tail fallback. */
  function forecastFor(cid) {
    var map = window.LRC_FORECAST_BY_CONTRACT;
    if (!map || !cid) return null;
    if (map[cid]) return map[cid];
    var tail = String(cid).replace(/[^0-9]/g, ""); if (!tail) return null;
    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i++) { if (String(keys[i]).replace(/[^0-9]/g, "") === tail) return map[keys[i]]; }
    return null;
  }
  function fcCopy() { return (window.LRC_FORECAST_CFG && window.LRC_FORECAST_CFG.copy) || {}; }
  function fcFill(tpl, f) {
    var t = String(tpl == null ? "" : tpl), m = {
      "{shipDate}": fmtDateShort(f.shipDate) || "", "{arriveDate}": fmtDateShort(f.arriveDate) || "",
      "{runLowDate}": fmtDateShort(f.runLowDate) || "", "{nextNextDelivery}": fmtDateShort(f.nextNextDelivery) || "",
      "{category}": f.bindingCategory || ""
    };
    for (var k in m) { if (m.hasOwnProperty(k)) t = t.split(k).join(m[k]); }
    return t;
  }
  /* state -> footer html, driven by cfg.copy. amber CTA (data-fc-quiz) opens the usage quiz; skip line is a
     standing note. A cfg value wins when present; an EXPLICIT blank hides the CTA button / skip line; the
     hardcoded default is used only when cfg omits the key entirely (engine cfg not loaded). */
  function forecastFooter(f, cp) {
    function msg(v, fallback) { return esc(fcFill((v != null) ? v : fallback, f)); }
    var skipTpl = (cp.skip_line != null) ? cp.skip_line : C.fcSkip;
    var skip = (skipTpl && String(skipTpl).trim()) ? ('<div class="tlskip">' + esc(fcFill(skipTpl, f)) + "</div>") : "";
    function cta(label) { return (label && String(label).trim()) ? ('<button type="button" class="tlcta" data-fc-quiz>' + esc(fcFill(label, f)) + "</button>") : ""; }
    var ctaOver = (cp.cta_overstocked != null) ? cp.cta_overstocked : C.fcCtaOver;
    var ctaNoRate = (cp.cta_no_rate != null) ? cp.cta_no_rate : C.fcCtaQuiz;
    switch (f.state) {
      case "short":
        return '<div class="tlalert warn"><span>' + msg(cp.short, C.fcShort) + "</span></div>" + skip;
      case "overstocked":
        return '<div class="tlalert over"><span>' + msg(cp.overstocked, C.fcOver) + "</span>" + cta(ctaOver) + "</div>";
      case "new":
        return '<div class="tlalert neutral"><span>' + msg(cp.new_sub, C.fcNew) + "</span></div>";
      case "no-rate":
        return '<div class="tlalert neutral"><span>' + msg(cp.no_rate, C.fcNoRate) + "</span>" + cta(ctaNoRate) + "</div>";
      case "on-track":
      default:
        return '<div class="tlalert ok"><span>' + msg(cp.on_track, C.fcOnTrack) + "</span></div>" + skip;
    }
  }
  function forecastCidFrom(c, dto) {
    return String((dto && (dto.subscriptionContractId || dto.contractId || dto.id)) || (c && (c.id || c.subscriptionContractId)) || "");
  }
  /* Consume the validated engine (window.LRC_FORECAST_BY_CONTRACT). If not ready yet, render nothing -
     the 'lrc:forecast-ready' listener repaints once the engine publishes. nextDate is no longer used. */
  function renderForecast(nextDate, c, dto) {
    var f = forecastFor(forecastCidFrom(c, dto));
    if (!f) { setHTML("drop-forecast", ""); return; }
    var nodes = [
      { cls: "ship", lab: C.tlShips, d: parseDate(f.shipDate) },
      { cls: "arrive", lab: C.tlArrives, d: parseDate(f.arriveDate) }
    ];
    if (f.runLowDate) nodes.push({ cls: "low", lab: C.tlRunlow, d: parseDate(f.runLowDate) });
    nodes = nodes.filter(function (n) { return n.d; });
    nodes.sort(function (x, y) { return x.d - y.d; });
    var rowhtml = '<div class="tlrow">' + nodes.map(function (n) {
      return '<div class="tlnode ' + n.cls + '"><div class="dot"></div><div class="tlab">' + esc(n.lab) + '</div><div class="tdate">' + esc(fmtDateShort(n.d.toISOString())) + "</div></div>"; }).join("") + "</div>";
    setHTML("drop-forecast", '<div class="tl">' + rowhtml + forecastFooter(f, fcCopy()) + "</div>");
    var q = root.querySelector("[data-fc-quiz]");
    if (q) q.addEventListener("click", function () { if (window.LRCMP && LRCMP.openQuiz) LRCMP.openQuiz(); });
  }

  function lineSavings(lines, cfg, dpb) {
    var per = dpb || 1;
    var save = 0, base = 0;   /* totals across lines that actually save (basePrice > per-unit) */
    lines.forEach(function (ln) {
      if (isConfiguredSample(ln, cfg)) return;
      var qty = num(pick(ln, ["quantity"], 1)) || 1;
      var cp = moneyVal(pick(ln, ["currentPrice"], null));
      var planUnit = (cp != null) ? (cp / per) : (moneyVal(pick(ln, ["lineDiscountedPrice.pricePerUnit"], null)) || 0);   /* prepaid currentPrice is per-billing → per-unit (PLAN/member price) */
      /* paid per-unit this cycle (post one-cycle save offer). lineDiscountedPrice is per-billing like currentPrice, so ÷per
         to match planUnit's per-shipment basis — mirrors the line-item branch's ÷lineDiv (663); per === lineDiv on these recurring lines. */
      var paidRaw = moneyVal(pick(ln, ["lineDiscountedPrice.pricePerUnit"], null));
      if (paidRaw == null) { var ldt = moneyVal(pick(ln, ["lineDiscountedPrice.amount", "lineDiscountedPrice"], null)); if (ldt != null) paidRaw = ldt / qty; }
      var paidUnit = (paidRaw != null) ? (paidRaw / per) : null;
      var cur = (paidUnit != null && paidUnit < planUnit - 0.005) ? paidUnit : planUnit;   /* use actually-charged price when a save offer makes it LOWER than plan; else plan price */
      var bp = moneyVal(pick(ln, ["pricingPolicy.basePrice"], null));
      if (bp != null && bp > cur) { save += (bp - cur) * qty; base += bp * qty; }
    });
    return { save: round2(save), base: round2(base) };
  }
  function renderSavingsAnchor(lines, currency, dpb) {
    var host = region("savings-anchor"); if (!host) return;
    if (!lines) { host.innerHTML = ""; return; }
    var r = lineSavings(lines, readSampleConfig(region("drop-items")), dpb);
    var pct = (r.base > 0) ? Math.round(r.save / r.base * 100) : 0;   /* % off vs. full retail across saving lines */
    var tpl = C.savings;
    if (tpl.indexOf("{pct}") === -1 && tpl.indexOf("${amount}") !== -1) tpl = "You're saving {pct}% this order";   /* migrate a stale dollar template */
    host.innerHTML = (pct > 0) ? '<div class="savings-anchor">' + esc(tpl.replace("{pct}", pct)) + "</div>" : "";
  }

  function readSampleConfig(el) {
    var ids = {}; if (el) (el.getAttribute("data-sample-ids") || "").split(",").forEach(function (raw) { var n = normId(raw); if (n) ids[n] = 1; });
    var giftIds = {}; if (el) (el.getAttribute("data-gift-ids") || "").split(",").forEach(function (raw) { var n = normId(raw); if (n) giftIds[n] = 1; });
    /* Try-it-free grant: the section root publishes the granted variant id once a claim exists. */
    var tfEl = document.querySelector("[data-lrct-root]");
    var tfVariant = normId((tfEl && tfEl.getAttribute("data-lrct-gift-variant")) || "");
    var tfTag = (tfEl && tfEl.getAttribute("data-lrct-gift-tag")) || "";
    var tfNote = (tfEl && tfEl.getAttribute("data-lrct-gift-note")) || "";
    return { show: !!el && el.getAttribute("data-sample-show") === "true", ids: ids, hasIds: Object.keys(ids).length > 0,
      tfVariant: tfVariant || null, tfTag: tfTag || null, tfNote: tfNote || null,
      giftIds: giftIds, hasGiftIds: Object.keys(giftIds).length > 0, giftBadge: ((el && el.getAttribute("data-gift-badge")) || "") || "Gift",
      title: (el && el.getAttribute("data-sample-title")) || "", subtitle: (el && el.getAttribute("data-sample-subtitle")) || "", image: (el && el.getAttribute("data-sample-image")) || "" };
  }
  function isConfiguredSample(ln, cfg) { if (!cfg || !cfg.hasIds) return false; var p = normId(pick(ln, ["productId"], "")), v = normId(pick(ln, ["variantId"], "")); return (p && cfg.ids[p]) || (v && cfg.ids[v]); }
  /* Effective per-unit price actually PAID on a line (post-discount), or null if unknown. Prefers the
     line's discounted price, else currentPrice minus its own discount allocations. */
  function effectiveUnitPaid(ln) {
    var qty = num(pick(ln, ["quantity"], 1)) || 1;
    var ldTotal = moneyVal(pick(ln, ["lineDiscountedPrice.amount", "lineDiscountedPrice"], null));
    if (ldTotal != null) return ldTotal / qty;
    var ldUnit = moneyVal(pick(ln, ["lineDiscountedPrice.pricePerUnit"], null));
    if (ldUnit != null) return ldUnit;
    var cp = moneyVal(pick(ln, ["currentPrice"], null));
    if (cp == null) return null;
    var disc = toArray(pick(ln, ["discountAllocations"], [])).reduce(function (acc, x) { return acc + (moneyVal(pick(x, ["amount", "discountAmount", "amount.amount"], null)) || 0); }, 0);
    return cp - (disc / qty);
  }
  /* Client mirror of sub.js isFreeGiftLine: a one-time line (no basePrice) whose EFFECTIVE per-unit price
     is 0. Precise per the boundary rule — a discounted-but-nonzero line (member pricing) is NOT free, so
     it never gets gift treatment. */
  function isFreeGiftLine(ln) {
    var basePrice = moneyVal(pick(ln, ["pricingPolicy.basePrice"], null));
    if (basePrice != null) return false;                 /* recurring line — never the free gift */
    var eff = effectiveUnitPaid(ln);
    return eff != null && Math.abs(eff) < 0.005;         /* effective per-unit === 0 (float-safe) */
  }
  /* Gift treatment (non-editable + FREE + badge chip) requires BOTH: the id is in the configured gift list
     AND the line is actually free. A PAID line of the same variant (member buying it) is a normal line. */
  function isConfiguredGift(ln, cfg) {
    if (!cfg || !cfg.hasGiftIds) return false;
    var p = normId(pick(ln, ["productId"], "")), v = normId(pick(ln, ["variantId"], ""));
    if (!((p && cfg.giftIds[p]) || (v && cfg.giftIds[v]))) return false;
    return isFreeGiftLine(ln);
  }
  /* Try-it-free granted line. Deliberately NOT isFreeGiftLine: that one rejects anything with a
     basePrice (i.e. every recurring line), and the try-free grant IS recurring — a real line on the
     member's plan whose FIRST cycle is priced to 0 by its pricingPolicy. Same boundary rule though:
     gift treatment requires variant match AND an effective per-unit of 0, so once the free cycle is
     consumed and the line prices at tier it falls through to a normal editable recurring row. */
  /* Try-it-free granted line. POLICY: this is an ordinary RECURRING line and stays fully editable —
     it is NOT given gift treatment. This predicate now only decides whether to show the small
     "first one's on us" tag, and only while the line is actually free; once the first cycle bills
     it prices at tier and renders as any other recurring row. */
  function isTryFreeLine(ln, cfg) {
    if (!cfg || !cfg.tfVariant) return false;
    if (normId(pick(ln, ["variantId"], "")) !== cfg.tfVariant) return false;
    var eff = effectiveUnitPaid(ln);
    return eff != null && Math.abs(eff) < 0.005;
  }
  /* Member (tier) unit price for the granted line, from its own pricingPolicy PERCENTAGE entry.
     basePrice x (100 - pct)/100. Used to price units beyond the free one. */
  function tryFreeTierUnit(ln) {
    var base = moneyVal(pick(ln, ["pricingPolicy.basePrice"], null));
    if (base == null) return null;
    var cyc = toArray(pick(ln, ["pricingPolicy.cycleDiscounts"], []));
    for (var i = 0; i < cyc.length; i++) {
      var d = cyc[i];
      if (String(pick(d, ["adjustmentType"], "")) === "PERCENTAGE") {
        var pct = Number(pick(d, ["adjustmentValue.percentage"], null));
        if (isFinite(pct)) return base * (100 - pct) / 100;
      }
    }
    return base;
  }
  function sampleRow(title, subtitle, image, badge) {
    var badgeTxt = (typeof badge === "string" && badge !== "") ? badge : C.sampleBadge;
    var thumb = image ? '<div class="thumb g"><img src="' + esc(image) + '" alt="' + esc(title) + '" loading="lazy"></div>' : '<div class="thumb g">' + esc(C.sampleThumb) + "</div>";
    return '<div class="item gift" data-sample-row>' + thumb + '<div class="txt"><span class="giftbadge">' + esc(badgeTxt) + '</span><div class="nm">' + esc(title) + '</div><div class="mt">' + esc(subtitle) + '</div></div><div class="rt"><div class="pr"><span class="now sd-free">' + esc(C.freeLabel) + "</span></div></div></div>";
  }

  /* Winback locked-gift pseudo-line (DISPLAY ONLY). Rendered last (gift position) when a pending winback
     gift exists for the shown contract. Image + note resolve from the winback section root's data
     attributes; absence of that root just omits the image / note. Non-interactive (pointer-events:none). */
  function winbackLockedTile(shortfallCents, currency) {
    var wbHost = document.querySelector("[data-lrcw-host]");
    var img = wbHost ? (wbHost.getAttribute("data-lrcw-gift-image") || "") : "";
    var noteTpl = wbHost ? (wbHost.getAttribute("data-lrcw-locked-note") || "") : "";
    var shortStr = fmtMoney((num(shortfallCents) || 0) / 100, currency) || "";
    var note = String(noteTpl).replace(/\{shortfall\}/g, shortStr);
    var lock = '<span style="display:flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:50%;background:#FDF6F0;box-shadow:0 2px 6px rgba(17,36,43,.35);isolation:isolate;">'
      + '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="5" y="10.5" width="14" height="9.5" rx="2.2" fill="#223F4E"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" stroke="#223F4E" stroke-width="2" fill="none"/></svg></span>';
    var imgLayer = img ? '<img src="' + esc(img) + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;filter:blur(3px);transform:scale(1.08);">' : "";
    var thumb = '<div class="thumb' + (img ? "" : " g") + '" style="isolation:isolate;">'
      + imgLayer
      + '<span style="position:absolute;inset:0;background:rgba(34,63,78,.35);isolation:isolate;"></span>'
      + '<span style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;isolation:isolate;">' + lock + "</span></div>";
    return '<div class="item gift" data-winback-locked style="pointer-events:none;">'
      + thumb
      + '<div class="txt"><div class="nm">Long Run Trail Hat</div>'
      + '<div class="mt" style="font-family:\'Saira Semi Condensed\',system-ui,sans-serif;font-weight:600;color:#223F4E;">' + esc(note) + "</div></div></div>";
  }

  var _lastIP = null;
  /* Recompute subtotal, member savings and the free-shipping bar from the CURRENT lines model and
     repaint ONLY the totals block. Deliberately re-runs renderItemsAndPricing rather than
     duplicating its arithmetic: the numbers cannot drift from what a reload shows, because it is
     the identical code path — the items DOM write is simply suppressed. */
  function recomputeTotals() {
    if (!_lastIP) return false;
    try {
      var L = _lastIP;
      renderItemsAndPricing(L.c, L.dto, L.lines, L.currency, L.opt, true);
      /* the standalone savings pill + anchor derive from the same lines */
      try {
        var _sv = L.active ? lineSavings(L.lines, readSampleConfig(region("drop-items")), L.dpb) : { base: 0, save: 0 };
        var pct = (_sv.base > 0) ? Math.round(_sv.save / _sv.base * 100) : 0;
        var oldB = root.querySelector(".sd-savings-badge"); if (oldB && oldB.parentNode) oldB.parentNode.removeChild(oldB);
        var recapEl = region("drop-recap");
        if (recapEl && recapEl.parentNode && pct > 0) {
          var badge = document.createElement("div");
          badge.className = "sd-savings-badge";
          badge.textContent = "You're saving " + pct + "% this order";
          recapEl.parentNode.insertBefore(badge, recapEl.nextSibling);
        }
        renderSavingsAnchor(L.lines, L.currency, L.dpb);
      } catch (e) {}
      return true;
    } catch (e) { if (window.console) console.warn("[lrc-mp] recomputeTotals:", e); return false; }
  }
  window.LRCMP_RECOMPUTE_TOTALS = recomputeTotals;

  function renderItemsAndPricing(c, dto, lines, currency, opt, totalsOnly) {
    var itemsEl = region("drop-items");
    var cfg = readSampleConfig(itemsEl);
    var dpb = deliveriesPerBilling(c, dto);   /* prepaid: charges/billing > 1; PAYG: 1 */
    /* Per-billing divisor for a single line. RECURRING lines on a prepaid contract carry per-billing-cycle
       prices AND discounts (Appstle stores both that way) → divide by dpb to show per-shipment. ONE-TIME lines
       (no basePrice and no sellingPlanId) are billed once, not ×dpb → divisor 1 (no normalization). PAYG → 1. */
    function lineDiv(ln) {
      if (dpb <= 1) return 1;
      var bp = moneyVal(pick(ln, ["pricingPolicy.basePrice"], null));
      var sp = pick(ln, ["sellingPlanId"], null);
      var recurring = (bp != null) || (sp != null && sp !== "");
      return recurring ? dpb : 1;
    }
    var sampleShown = false, retailSubtotal = 0, memberSubtotal = 0, allocTotal = 0, giftTitles = [];
    function tally(ln) {
      var qty = num(pick(ln, ["quantity"], 1)) || 1;
      var div = lineDiv(ln);
      var cpRaw = moneyVal(pick(ln, ["currentPrice"], null));
      var unit = (cpRaw != null) ? (cpRaw / div) : moneyVal(pick(ln, ["lineDiscountedPrice.pricePerUnit"], null));   /* normalize prepaid per-billing → per-unit (recurring only) */
      if (unit == null) { var ld = moneyVal(pick(ln, ["lineDiscountedPrice"], null)); unit = (ld != null) ? ld / qty : 0; }
      var cmp = moneyVal(pick(ln, ["pricingPolicy.basePrice", "pricingPolicy.cycleDiscounts.0.computedPrice"], null));
      var unitRetail = (cmp != null && cmp > unit) ? cmp : unit;
      var lineDisc = toArray(pick(ln, ["discountAllocations"], [])).reduce(function (acc, x) { return acc + (moneyVal(pick(x, ["amount", "discountAmount", "amount.amount"], null)) || 0); }, 0) / div;   /* discount allocation is per-billing too → normalize per-shipment */
      /* TRY-IT-FREE: the row shows tier x (qty-1) because the first unit is free. The subtotal has
         to agree, and unit*qty would count the whole line as $0 at any quantity. Same helper the row
         uses (tryFreeTierUnit), so the two can never disagree. */
      var lineTotal = unit * qty;
      if (unit === 0 && isTryFreeLine(ln, cfg)) {
        var tfu = tryFreeTierUnit(ln);
        if (tfu != null) lineTotal = tfu * Math.max(0, qty - 1);
      }
      memberSubtotal += lineTotal; retailSubtotal += unitRetail * qty; allocTotal += lineDisc;
      return { qty: qty, unit: unit, unitRetail: unitRetail };
    }
    function isFree(ln) { var u = moneyVal(pick(ln, ["currentPrice", "lineDiscountedPrice.pricePerUnit"], null)); return u === 0; }

    /* Variant catalog from the add module (pillars[].products[].variants[]), keyed by trailing numeric id. */
    /* compare_at_price / price here are in CENTS (Shopify Liquid money), so divide by 100 before fmtMoney. */
    function vidKey(x) { x = String(x == null ? "" : x); var m = x.match(/(\d+)\s*$/); return m ? m[1] : x; }
    var VCAT = (function () {
      var map = {};
      try {
        var am = window.LRCMP_ADD_MODULE, pillars = (am && am.pillars) || [];
        for (var i = 0; i < pillars.length; i++) {
          var prods = (pillars[i] && pillars[i].products) || (pillars[i] && pillars[i].variants ? [pillars[i]] : []);
          for (var j = 0; j < prods.length; j++) {
            var vs = (prods[j] && prods[j].variants) || [];
            for (var k = 0; k < vs.length; k++) { var v = vs[k]; if (v && v.id != null) map[vidKey(v.id)] = v; }
          }
        }
      } catch (e) {}
      return map;
    })();

    if (itemsEl) {
      var realSample = false;
      var deco = lines.map(function (ln, idx) {
        var gtier = 0;
        if (isConfiguredGift(ln, cfg)) gtier = 1;
        else if (isConfiguredSample(ln, cfg) || isFree(ln)) gtier = 2;
        return { ln: ln, idx: idx, last: (isConfiguredSample(ln, cfg) || isFree(ln)) ? 1 : 0, gtier: gtier };
      });
      deco.sort(function (a, b) { return (a.gtier - b.gtier) || (a.idx - b.idx); });   /* normal(0) → save gift(1) → sample/free(2) last; stable by original index */
      var rows = deco.map(function (o) {
        var ln = o.ln, idx = o.idx;
        if (isConfiguredSample(ln, cfg)) {
          realSample = true;
          var sTitle = pick(ln, ["title", "productTitle"], cfg.title || "");
          giftTitles.push(sTitle);                                       /* fix C: real title in breakdown */
          var sQty = num(pick(ln, ["quantity"], 1)) || 1, sVar = pick(ln, ["variantTitle"], "");
          var sImg = pick(ln, ["variantImage.url", "variantImage.transformedSrc", "variantImage.src"], null) || cfg.image;
          return sampleRow(sTitle, (sVar ? sVar + C.sep : "") + C.sampleQty + " " + sQty, sImg);
        }
        if (isConfiguredGift(ln, cfg)) {
          /* save-offer gift: non-editable gift row from the LINE's own fields; does NOT set realSample, so the ghost still injects at the loop tail */
          var gTitle = pick(ln, ["title", "productTitle"], "Gift");
          var gVar = pick(ln, ["variantTitle"], "");
          var gImg = pick(ln, ["variantImage.url", "variantImage.transformedSrc", "variantImage.src"], null);
          return sampleRow(gTitle, gVar, gImg, cfg.giftBadge);
        }
        var t = tally(ln);
        var title = esc(pick(ln, ["title"], "Item")), variant = esc(pick(ln, ["variantTitle"], ""));
        var img = pick(ln, ["variantImage.url", "variantImage.transformedSrc", "variantImage.src"], null);
        var thumb = img ? '<div class="thumb"><img src="' + esc(img) + '" alt="' + title + '" loading="lazy"></div>' : '<div class="thumb">' + esc(title.slice(0, 8)) + "</div>";
        var free = (t.unit === 0), giftCls = free ? " gift" : "";
        if (free) giftTitles.push(pick(ln, ["title", "productTitle"], ""));   /* fix C */
        var qty = t.qty;
        var curRaw = moneyVal(pick(ln, ["currentPrice"], null));
        var curUnit = (curRaw != null) ? (curRaw / lineDiv(ln)) : t.unit;   /* recurring prepaid → per-shipment; one-time/PAYG → as-is (not ×dpb) */
        var basePrice = moneyVal(pick(ln, ["pricingPolicy.basePrice"], null));                            /* present ONLY on recurring lines */
        var ldTotal = moneyVal(pick(ln, ["lineDiscountedPrice.amount", "lineDiscountedPrice"], null));     /* TOTAL price actually paid (post-discount) */
        var paidPerUnit = (ldTotal != null) ? (ldTotal / qty) : moneyVal(pick(ln, ["lineDiscountedPrice.pricePerUnit"], null));
        var isRecurring = (basePrice != null);                                /* GROUND TRUTH: pricingPolicy.basePrice, NOT sellingPlanId */
        var oneTime = !isRecurring && !free && curUnit > 0;                    /* one-time = no basePrice, paid line (excludes free gifts) */
        var otBadge = oneTime ? '<span class="onetime-badge">' + esc(C.oneTimeBadge) + "</span>" : "";
        var pr;
        var isTF = isTryFreeLine(ln, cfg);
        if (free && isTF) {
          /* Try-it-free: the FIRST unit is free, any extra units bill at the member tier. Show the
             honest line total (tier x (qty-1)) rather than $0 or full retail x qty. Appstle reports
             computedPrice per UNIT while the free leg is active, so lineDiscountedPrice reads 0 at
             any quantity and cannot be trusted here — the total is derived from the tier entry. */
          var tfUnit = tryFreeTierUnit(ln);
          var payFor = Math.max(0, qty - 1);
          if (tfUnit != null && payFor > 0) {
            /* No note here — the "First one's on us" tag in the title column already says it. */
            pr = '<span class="now">' + esc(fmtMoney(tfUnit * payFor, currency)) + "</span>";
          } else {
            var struckTF = (t.unitRetail > 0) ? '<span class="was">' + esc(fmtMoney(t.unitRetail, currency)) + "</span>" : "";
            pr = struckTF + '<span class="now sd-free">' + esc(C.freeLabel) + "</span>";
          }
        } else if (free) {
          /* (d) free gift — unchanged */
          var struck = (t.unitRetail > 0) ? '<span class="was">' + esc(fmtMoney(t.unitRetail * qty, currency)) + "</span>" : "";
          pr = struck + '<span class="now sd-free">' + esc(C.freeLabel) + "</span>";
        } else if (isRecurring) {
          /* (a) recurring. If a per-ORDER discount is allocated to THIS line (e.g. a redeemed reward applied to the
             existing recurring line), show <s>currentPrice</s> discountedPrice — same treatment as branch (b).
             paidPerUnit (648) is NOT lineDiv-divided, so put it on curUnit's per-shipment basis first (÷lineDiv);
             on PAYG lineDiv=1 → unchanged, on prepaid → ÷deliveries-per-billing to match curUnit at 645. Otherwise
             keep the existing <s>basePrice</s> currentPrice sale display. */
          var paidPerUnitShip = (paidPerUnit != null) ? (paidPerUnit / lineDiv(ln)) : null;
          if (paidPerUnitShip != null && paidPerUnitShip < curUnit - 0.005) {
            var wasD = (basePrice != null && basePrice > paidPerUnitShip + 0.005) ? '<span class="was">' + esc(fmtMoney(basePrice * qty, currency)) + "</span>" : "";   /* strike = RETAIL (basePrice), never the member/sub price */
            pr = wasD + '<span class="now">' + esc(fmtMoney(paidPerUnitShip * qty, currency)) + "</span>";
          } else {
            var wasR = (basePrice > curUnit) ? '<span class="was">' + esc(fmtMoney(basePrice * qty, currency)) + "</span>" : "";
            pr = wasR + '<span class="now">' + esc(fmtMoney(curUnit * qty, currency)) + "</span>";
          }
        } else if (paidPerUnit != null && paidPerUnit < curUnit - 0.005) {
          /* (b) one-time WITH discount — <s>currentPrice</s> paidPerUnit (lineDiscountedPrice.amount / qty) */
          pr = '<span class="was">' + esc(fmtMoney(curUnit * qty, currency)) + '</span><span class="now">' + esc(fmtMoney(paidPerUnit * qty, currency)) + "</span>";
        } else {
          /* (c) one-time WITHOUT a lineDiscountedPrice differential — look up variant catalog for retail. */
          var vcat = VCAT[vidKey(pick(ln, ["variantId"], ""))];
          var caC = vcat ? moneyVal(vcat.compare_at_price) : null;            /* cents */
          var vpC = vcat ? moneyVal(vcat.price) : null;                        /* cents = variant RETAIL */
          var retailUnit = (vpC != null) ? (vpC / 100) : null;                 /* dollars (curUnit is dollars) */
          if (retailUnit == null) {
            /* Fallback: the launch block publishes window.LRCMP_LAUNCH_RETAIL[variantId] in CENTS (read live each
               render, so it's picked up once the launch section's synchronous script has run). Convert cents→dollars
               to match retailUnit/curUnit. Decouples launch strikethrough from the +Add module's VCAT collections. */
            var lrC = (window.LRCMP_LAUNCH_RETAIL || {})[vidKey(pick(ln, ["variantId"], ""))];
            if (lrC != null && isFinite(Number(lrC))) retailUnit = Number(lrC) / 100;
          }
          if (oneTime && retailUnit != null && retailUnit > curUnit + 0.005) {
            /* Launch member pricing: a discounted one-time line (currentPrice repriced below variant retail).
               <s>retail</s> memberPrice + "Member price" tag. Reuses .was/.now so it matches every other row;
               guarded — if retail is unavailable it falls through to today's plain/compare-at rendering below. */
            pr = '<span class="was">' + esc(fmtMoney(retailUnit * qty, currency)) + '</span>'
               + '<span class="now">' + esc(fmtMoney(curUnit * qty, currency)) + '</span>'
               + '<span class="member-price-tag">' + esc(C.memberPriceLabel) + '</span>';
          } else {
            var wasC = (caC != null && vpC != null && caC > vpC) ? '<span class="was">' + esc(fmtMoney((caC / 100) * qty, currency)) + "</span>" : "";
            pr = wasC + '<span class="now">' + esc(fmtMoney(curUnit * qty, currency)) + "</span>";
          }
        }
        var lineId = pick(ln, ["id"], ""), variantId = pick(ln, ["variantId"], "");
        var tfTag = isTF ? '<span class="tf-granted-tag">' + esc(cfg.tfTag || "First one\u2019s on us") + "</span>" : "";
        var editAff = opt.ended ? "" : '<span class="edit-icon" role="button" tabindex="0" aria-label="Edit item" onclick="LRCMP.openEdit(' + idx + ', \'' + esc(lineId) + '\')">' + PENCIL + "</span>";
        return '<div class="item' + giftCls + '" data-line-id="' + esc(lineId) + '" data-variant-id="' + esc(variantId) + '" data-quantity="' + t.qty + '" data-title="' + title + '">' + thumb + '<div class="txt">' + otBadge + '<div class="nm">' + title + "</div><div class=\"mt\">" + (variant ? variant + C.sep : "") + C.qtySep + t.qty + "</div>" + tfTag + editAff + '</div><div class="rt"><div class="pr">' + pr + "</div></div></div>";
      });
      if (realSample) { sampleShown = true; }
      else if (cfg.show) { rows.push(sampleRow(cfg.title || "", cfg.subtitle || "", cfg.image)); sampleShown = true; giftTitles.push(cfg.title || ""); }
      /* Winback locked tile — display only, last position. Absence of the flag = zero change.
         Suppress it ONLY when an ACTUALLY-FREE gift-variant line is present (variant match AND effective
         per-unit 0, via isFreeGiftLine). A PAID line of the gift variant (member bought the hat) must NOT
         suppress the tile — otherwise the pending offer silently disappears. */
      try {
        var _wb = window.LRCMP_WINBACK_PENDING;
        if (_wb && String(_wb.contractId) === String(combineCid(dto))) {
          var _wbHost = document.querySelector("[data-lrcw-host]");
          var _gvar = _wbHost ? String(_wbHost.getAttribute("data-lrcw-gift-variant") || "").replace(/[^0-9]/g, "") : "";
          var _hasReal = _gvar && lines.some(function (ln) { return String(pick(ln, ["variantId"], "")).replace(/[^0-9]/g, "") === _gvar && isFreeGiftLine(ln); });
          if (!_hasReal) rows.push(winbackLockedTile(_wb.shortfallCents, currency));
        }
      } catch (e) {}
      if (!totalsOnly) setHTML("drop-items", rows.join("") || '<div class="sub">' + esc(C.emptyItems) + "</div>");   /* totalsOnly: rows still built (they tally) but never painted */
    } else { lines.forEach(function (ln) { if (!isConfiguredSample(ln, cfg)) tally(ln); }); }

    var memberSavings = round2(retailSubtotal - memberSubtotal);
    memberSubtotal = round2(memberSubtotal); retailSubtotal = round2(retailSubtotal);
    var deliveryPrice = moneyVal(pick(c, ["deliveryPrice"], null)); if (deliveryPrice == null) deliveryPrice = 0;
    var belowThreshold = memberSubtotal < FREE_SHIP;
    var discountApplied = round2(allocTotal); if (discountApplied < 0.01) discountApplied = 0;
    /* contract-level discounts (e.g. an applied promo code) are stored per-billing-cycle → normalize per-shipment on prepaid */
    var cDiscDiv = (dpb > 1 ? dpb : 1);
    var cDisc = toArray(pick(c, ["discounts.nodes", "discounts"], [])).map(function (d) { return { title: pick(d, ["title", "code", "name"], C.pDiscount), amount: (moneyVal(pick(d, ["amount", "value", "amount.amount"], null)) || 0) / cDiscDiv }; }).filter(function (d) { return d.amount > 0; });
    var cDiscSum = round2(cDisc.reduce(function (acc, d) { return acc + d.amount; }, 0));
    /* An applied code surfaces BOTH as per-line allocations (discountApplied) and as a contract discount
       (cDiscSum) — same discount, two forms. Collapse to one (max), so the total isn't double-subtracted. */
    var discountTotal = Math.max(round2(discountApplied), round2(cDiscSum));
    var orderTotal = round2(memberSubtotal - discountTotal);   /* fix D: Total excludes shipping */

    if (has("drop-addzone")) {
      var barFree = !belowThreshold || hasFreeShipCode(c);   /* over threshold OR an active free-ship save-offer code forces the achieved bar */
      if (!opt.active) { setHTML("drop-addzone", ""); }
      else if (!barFree) {
        var remaining = round2(FREE_SHIP - memberSubtotal);
        var pct = Math.max(0, Math.min(100, (memberSubtotal / FREE_SHIP) * 100));
        setHTML("drop-addzone", '<div class="fsadd under"><div class="t">' + esc(C.freeShipProgress.replace(/\$?\{diff\}/, fmtMoney(remaining, currency))) + '</div>' +   /* \$? swallows any stray literal $ before {diff} (no double-dollar) */
          '<div class="track"><div class="fill" style="width:' + pct.toFixed(0) + '%"></div></div>' +
          '<button class="addbtn" data-sd-addbtn>' + esc(C.addbtn) + "</button></div>");   /* full-width +Add lives with the free-ship progress */
      } else {
        var metCopy = hasFreeShipCode(c) ? C.freeshipMetCode : C.freeshipMet;   /* code-driven free ship uses "every order" framing */
        setHTML("drop-addzone", '<div class="freeship-met">' + esc(metCopy) + '</div><button class="addbtn" data-sd-addbtn>' + esc(C.addbtn) + "</button>");
      }
    }

    if (has("drop-summary")) {
      var sr = "";
      sr += srow(C.pSubtotal, esc(fmtMoney(retailSubtotal, currency)));
      if (memberSavings > 0) sr += srow(C.pMember, "−" + esc(fmtMoney(memberSavings, currency)), "save");
      if (discountTotal > 0) sr += srow(C.pDiscount, "−" + esc(fmtMoney(discountTotal, currency)), "save");   /* ONE collapsed row; codes stay visible/removable via the promo chips */
      giftTitles.forEach(function (tt) { sr += srow(tt || C.pFreeGift, '<span class="free">' + esc(C.freeLabel) + "</span>"); });   /* fix C */
      var shipFree = !belowThreshold || hasFreeShipCode(c);   /* over threshold OR an active free-ship save-offer code forces FREE */
      sr += srow(C.shippingRowLabel, shipFree ? '<span class="free">' + esc(C.pFreeShip) + "</span>" : '<span class="ship-note">' + esc(C.pShipping) + "</span>");   /* fix D */
      sr += '<div class="srow tot"><span>' + esc(C.pTotal) + '</span><span>' + esc(fmtMoney(orderTotal, currency)) + "</span></div>";
      setHTML("drop-summary", sr);
    }
  }

  /* ---------- promo code apply / remove ---------- */
  function proxyBase() {
    var r = document.querySelector("[data-lrc-member-portal]");
    var b = (r && r.getAttribute("data-proxy-base")) || "/apps/subscriptions/cp/api/";
    return b.replace(/\/+$/, "") + "/";
  }
  /* Re-fetch the active contract and re-publish so pricing (savings bubble, line prices, summary) re-renders
     in place. The promo box is static markup (not a re-rendered region), so its applied/error state persists. */
  function refreshActivePricing() {
    var i = activeIndex(), cid = contractIdAt(i);
    var subs = window.LRCMP_SUBS;
    if (!cid || !subs || !subs.contracts || !subs.contracts[i]) { try { location.reload(); } catch (e) {} return; }
    fetch(proxyBase() + "subscription-contracts/contract/" + encodeURIComponent(cid), { credentials: "same-origin", headers: { "Accept": "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (contract) {
        if (contract) { subs.contracts[i].contract = contract; try { document.dispatchEvent(new CustomEvent("lrc-mp:subscription", { detail: subs })); } catch (e) {} }
        else { try { location.reload(); } catch (e) {} }
      })
      .catch(function () { try { location.reload(); } catch (e) {} });
  }

  /* ---- in-place refresh after a subscription edit (item add/remove/qty + quiz save). Combine flow is out of scope. ---- */
  /* find the active contract's entry in a raw get_forecast payload (exact id, then numeric-tail fallback) */
  function fcFindCt(fc, cid) {
    if (!fc || !fc.forecast || !cid) return null;
    var F = fc.forecast, tail = String(cid).replace(/[^0-9]/g, ""), k;
    for (k = 0; k < F.length; k++) { if (String(F[k].contractId) === String(cid)) return F[k]; }
    for (k = 0; k < F.length; k++) { if (String(F[k].contractId).replace(/[^0-9]/g, "") === tail) return F[k]; }
    return null;
  }
  /* signature of a contract's line items + quantities, for detecting when a write has propagated to get_forecast */
  function fcLinesSig(fc, cid) {
    var ct = fcFindCt(fc, cid); if (!ct) return null;
    return (ct.lineItems || []).map(function (x) { return String(x.productId || x.variantId || "") + ":" + (x.quantity == null ? 0 : x.quantity); }).sort().join("|");
  }
  /* Repaint the card immediately + recompute the forecast. ITEM edits: dispatch 'lrc-mp:contract-changed' (card
     repaint via refreshActivePricing), then refresh the forecast with a propagation-aware retry [600,1200,1800ms]
     until the active contract's lines change (best effort after 3 tries). RATE-only edits (quiz {member:true}):
     no line change -> skip the card repaint + retry, a single member refresh is correct. Never throws. */
  /* In-place quantity apply for the TRY-IT-FREE line only.
     The portal's normal post-save path calls LRCMP_REFRESH_AFTER_CHANGE, which re-fetches and
     repaints the whole card on a 600/1200/1800ms ladder — that late repaint is what reads as the
     page refreshing itself a beat after you finish. This line's price is fully derivable from data
     already on the page (FREE at qty 1, tier x (qty-1) beyond), so we update the row directly and
     skip the refresh entirely. Returns false if anything is unexpected, so the caller can fall back
     to the normal refresh rather than leave a stale row. */
  window.LRCMP_TF_QTY_APPLY = function (lineId, qty) {
    try {
      if (!lineId) return false;
      var row = root.querySelector('.item[data-line-id="' + String(lineId).replace(/"/g, '\\"') + '"]');
      if (!row) return false;
      qty = Math.max(1, parseInt(qty, 10) || 1);

      var bundle = window.LRCMP_SUBS && window.LRCMP_SUBS.contracts && window.LRCMP_SUBS.contracts[window.LRCMP_SUB_ACTIVE || 0];
      var lines = toArray(pick(bundle, ["contract.lines.nodes", "contract.lines"], []));
      var ln = null;
      for (var i = 0; i < lines.length; i++) { if (String(pick(lines[i], ["id"], "")) === String(lineId)) { ln = lines[i]; break; } }
      if (!ln) return false;

      var tierUnit = tryFreeTierUnit(ln);
      if (tierUnit == null) return false;
      /* currencyOf() expects a MoneyV2, not a bundle — take it from the line's own price,
         falling back to the contract dto the same way the main render does. */
      var cur = currencyOf(pick(ln, ["currentPrice"], null),
                           pick(bundle, ["dto.currencyCode"], null) || "USD");

      row.setAttribute("data-quantity", String(qty));
      var mt = row.querySelector(".mt");
      if (mt) mt.textContent = mt.textContent.replace(/(\d+)\s*$/, String(qty));   /* trailing qty number */
      var pr = row.querySelector(".pr");
      if (pr) {
        pr.innerHTML = (qty > 1)
          ? '<span class="now">' + esc(fmtMoney(tierUnit * (qty - 1), cur)) + "</span>"
          : '<span class="now sd-free">' + esc(C.freeLabel) + "</span>";
      }
      /* keep the in-memory model in step so a later render agrees with what is on screen */
      try { ln.quantity = qty; } catch (e) {}
      /* subtotal / member savings / free-ship bar, recomputed from the mutated model — no re-fetch */
      recomputeTotals();
      return true;
    } catch (e) { return false; }
  };

  window.LRCMP_REFRESH_AFTER_CHANGE = function (opts) {
    try {
      opts = opts || {};
      if (opts.member === true) {
        if (!window.LRCMP_FORECAST || !window.LRCMP_FORECAST.refresh) return Promise.resolve(null);
        return window.LRCMP_FORECAST.refresh(opts).catch(function () { return null; });
      }
      var cid = contractIdAt(activeIndex());
      var preSig = fcLinesSig(window.LRC_FORECAST_RAW, cid);   /* capture BEFORE the repaint / re-fetch */
      try { document.dispatchEvent(new CustomEvent("lrc-mp:contract-changed")); } catch (e) {}
      /* The ladder exists because Appstle can lag a beat behind a write. Paths that only need the
         repaint promptly (add / remove, where the LINE SET changed and the ids are server-owned)
         pass immediate:true to take a single attempt with no delay — the 1.8s late repaint is what
         reads as the page refreshing itself after you have moved on. */
      var delays = (opts && opts.immediate === true) ? [0] : [600, 1200, 1800];
      return new Promise(function (resolve) {
        function attempt(k) {
          if (!window.LRCMP_FORECAST || !window.LRCMP_FORECAST.refresh) { resolve(null); return; }
          window.LRCMP_FORECAST.refresh(opts).then(function (fc) {
            var sig = fcLinesSig(fc, cid);
            var changed = (sig != null && preSig != null && sig !== preSig);
            if (changed || k >= delays.length - 1) { resolve(fc || null); return; }
            setTimeout(function () { attempt(k + 1); }, delays[k + 1] - delays[k]);
          }, function () {
            if (k >= delays.length - 1) { resolve(null); return; }
            setTimeout(function () { attempt(k + 1); }, delays[k + 1] - delays[k]);
          });
        }
        setTimeout(function () { attempt(0); }, delays[0]);
      });
    } catch (e) { if (window.console) console.warn("[lrc-mp] refresh-after-change:", e); return Promise.resolve(null); }
  };

  function promoEls() {
    var wrap = root.querySelector("[data-promo-wrap]"); if (!wrap) return null;
    return {
      wrap: wrap, applied: wrap.querySelector("[data-promo-applied]"), toggle: wrap.querySelector("[data-promo-toggle]"),
      field: wrap.querySelector("[data-promo-field]"), input: wrap.querySelector("[data-promo-input]"),
      apply: wrap.querySelector("[data-promo-apply]"), error: wrap.querySelector("[data-promo-error]")
    };
  }
  function promoErrorText(reason) {
    if (reason === "not_found") return C.promoErrNotFound;
    if (reason === "expired") return C.promoErrExpired;
    if (reason === "not_applicable") return C.promoErrNotApplicable;
    if (reason === "already_applied") return C.promoErrAlreadyApplied;
    return C.promoErrUnknown;
  }
  function promoShowError(els, msg) { if (els.error) { els.error.textContent = msg; els.error.hidden = false; } }
  /* Reset the input row to a clean state (BUG 4): canonical button label, enabled, cleared input, no error/red border. */
  function promoResetField(els) {
    if (els.apply) { els.apply.disabled = false; var lbl = els.apply.getAttribute("data-apply-label"); if (lbl) els.apply.textContent = lbl; }
    if (els.input) { els.input.value = ""; els.input.classList.remove("invalid"); }
    if (els.error) els.error.hidden = true;
  }
  /* Contract-level applied discounts (NOT plan cycleDiscounts — those live on line.pricingPolicy, never here). */
  function contractAppliedDiscounts(c) {
    var d = c && (c.discounts || (c.contract && c.contract.discounts));
    if (!d) return [];
    var arr = Array.isArray(d) ? d : Array.isArray(d.nodes) ? d.nodes : Array.isArray(d.edges) ? d.edges.map(function (e) { return e && e.node; }).filter(Boolean) : [];
    return arr.map(function (x) {
      return { id: pick(x, ["id"], null), label: pick(x, ["code", "title", "name"], "Discount"), amount: moneyVal(pick(x, ["amount", "value", "amount.amount"], null)) };
    }).filter(function (x) { return x.id != null; });   /* only removable (has an id) */
  }
  /* True when a configured free-shipping save-offer code is active on the contract. Reads the RAW discounts
     (not the filtered summary lists) because a free-ship discount may carry amount 0 and be filtered out. */
  function hasFreeShipCode(c) {
    if (!FREE_SHIP_CODES.length) return false;
    var d = c && (c.discounts || (c.contract && c.contract.discounts));
    if (!d) return false;
    var arr = Array.isArray(d) ? d : Array.isArray(d.nodes) ? d.nodes : Array.isArray(d.edges) ? d.edges.map(function (e) { return e && e.node; }).filter(Boolean) : [];
    for (var i = 0; i < arr.length; i++) {
      var lbl = pick(arr[i], ["code", "title", "name"], "");
      if (lbl && FREE_SHIP_CODES.indexOf(String(lbl).trim().toLowerCase()) !== -1) return true;
    }
    return false;
  }
  /* Render the promo box from contract data (source of truth): applied chips when codes exist, link/input otherwise. */
  function renderPromoState(c, dto) {
    var els = promoEls(); if (!els || !els.applied) return;
    var dpb = deliveriesPerBilling(c, dto), div = (dpb > 1 ? dpb : 1);
    var applied = contractAppliedDiscounts(c);
    var aria = els.wrap.getAttribute("data-promo-remove-aria") || "Remove promo code";
    if (applied.length) {
      els.applied.innerHTML = applied.map(function (x) {
        var amt = (x.amount != null) ? (x.amount / div) : null;   /* per-shipment on prepaid, matching the summary */
        var txt = (amt != null)
          ? C.promoSuccess.replace("{code}", x.label).replace("{amount}", amt.toFixed(2))
          : "Applied: " + x.label;
        return '<div class="promo-success"><span class="promo-success-txt">' + esc(txt) + '</span>' +
          '<button type="button" class="promo-remove" data-promo-remove data-disc-id="' + esc(x.id) + '" aria-label="' + esc(aria) + '">×</button></div>';
      }).join("");
      els.applied.hidden = false;
    } else {
      els.applied.innerHTML = "";
      els.applied.hidden = true;
    }
    /* either way, collapse the input row and reset it; the "Have a promo code?" link stays available to add another */
    if (els.field) els.field.hidden = true;
    promoResetField(els);
  }
  function promoApply(els) {
    var code = ((els.input && els.input.value) || "").trim();
    if (!code) { if (els.input) { els.input.classList.add("invalid"); els.input.focus(); } return; }   /* empty → red border, no API call */
    if (els.input) els.input.classList.remove("invalid");
    if (els.error) els.error.hidden = true;
    var btn = els.apply, lbl = (btn && btn.getAttribute("data-apply-label")) || (btn ? btn.textContent : "");
    if (btn) { btn.disabled = true; btn.textContent = C.promoApplying; }
    var cid = contractIdAt(activeIndex());
    fetch("/apps/lrc", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ action: "apply_discount_code", contractId: cid, code: code }) })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (j) {
        if (j && j.ok) {
          /* source of truth = contract data: collapse the input and re-fetch; renderPromoState shows the chip */
          if (els.field) els.field.hidden = true;
          if (btn) { btn.disabled = false; btn.textContent = lbl; }   /* BUG 4: never leave the button stuck in "Applying…" */
          if (els.input) { els.input.value = ""; els.input.classList.remove("invalid"); }
          if (els.error) els.error.hidden = true;
          refreshActivePricing();
        } else if (j && j.ok === false) {
          if (btn) { btn.disabled = false; btn.textContent = lbl; }
          if (els.input) els.input.classList.add("invalid");   /* BUG 1: red border on any apply failure */
          promoShowError(els, promoErrorText(j.reason));
        } else { throw new Error("bad_response"); }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = lbl; }
        if (els.input) els.input.classList.add("invalid");     /* BUG 1: red border on network error */
        promoShowError(els, C.promoErrNetwork);
      });
  }
  function promoRemove(discountId, chipBtn) {
    if (!discountId) return;
    var cid = contractIdAt(activeIndex());
    if (chipBtn) chipBtn.disabled = true;
    fetch("/apps/lrc", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ action: "remove_discount_code", contractId: cid, discountId: discountId }) })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (j) {
        if (j && j.ok) { refreshActivePricing(); }   /* re-fetch → renderPromoState drops the chip from fresh data */
        else { if (chipBtn) chipBtn.disabled = false; var els = promoEls(); if (els) promoShowError(els, "Couldn't remove — try again"); }
      })
      .catch(function () { if (chipBtn) chipBtn.disabled = false; var els = promoEls(); if (els) promoShowError(els, "Couldn't remove — try again"); });
  }
  function wirePromo() {
    var els = promoEls(); if (!els) return;
    if (els.apply && !els.apply.getAttribute("data-apply-label")) els.apply.setAttribute("data-apply-label", (els.apply.textContent || "Apply").trim());
    if (els.toggle) els.toggle.addEventListener("click", function () {
      var show = els.field && els.field.hidden;   /* about to reveal the input */
      if (els.field) els.field.hidden = !els.field.hidden;
      if (show) promoResetField(els);             /* BUG 4: reset button/input/error whenever the input re-shows */
      else if (els.error) els.error.hidden = true;
      if (els.field && !els.field.hidden && els.input) els.input.focus();
    });
    if (els.apply) els.apply.addEventListener("click", function () { promoApply(els); });
    if (els.input) {
      els.input.addEventListener("input", function () { els.input.classList.remove("invalid"); });
      els.input.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.keyCode === 13) { e.preventDefault(); promoApply(els); } });
    }
    /* delegate chip × clicks (chips are rendered dynamically per applied code) */
    els.wrap.addEventListener("click", function (e) {
      var b = e.target && e.target.closest ? e.target.closest("[data-promo-remove]") : null;
      if (b) { e.preventDefault(); promoRemove(b.getAttribute("data-disc-id"), b); }
    });
  }

  root.addEventListener("click", function (e) {
    var t = e.target && e.target.closest ? e.target.closest("[data-sd-reactivate]") : null;
    if (t) {
      e.preventDefault();
      var errEl = root.querySelector("[data-sd-err]");
      subWrite({ action: "reactivate", contractId: contractIdAt(activeIndex()), reason: t.getAttribute("data-reason") || "reactivate" }, t, errEl, function () {
        t.textContent = C.reactivateSuccess; setTimeout(function () { try { location.reload(); } catch (e) {} }, 1800);
      });
      return;
    }
    if (e.target && e.target.closest && e.target.closest("[data-sd-add], [data-sd-addbtn]")) { if (window.LRCMP && LRCMP.openAdd) LRCMP.openAdd(ROSTER); }
  });

  function sampleDate(days) { var t = new Date(); t.setDate(t.getDate() + days); return t.toISOString(); }
  function sLine(t, v, q, p, c, sp) { var n = { id: "gid://shopify/SubscriptionLine/" + q + "-" + p, variantId: "1", title: t, variantTitle: v, quantity: q, currentPrice: { amount: String(p), currencyCode: "USD" }, sellingPlanId: sp ? "sp1" : null }; if (c != null) n.pricingPolicy = { basePrice: { amount: String(c), currencyCode: "USD" } }; return n; }
  function sampleData() {
    function b(days, ic, status, lines) { return { dto: { status: status, nextBillingDate: sampleDate(days), cancelledOn: status === "cancelled" ? sampleDate(-18) : null, pausedOn: status === "paused" ? sampleDate(-9) : null, currencyCode: "USD", deliveryPolicyInterval: "DAY", deliveryPolicyIntervalCount: ic, billingPolicyInterval: "DAY", billingPolicyIntervalCount: ic },
      contract: { deliveryPrice: { amount: "7.99", currencyCode: "USD" }, billingPolicy: { interval: "DAY", intervalCount: ic }, deliveryMethod: { address: { city: "Boulder", provinceCode: "CO" } }, lines: { nodes: lines } },
      payment: { cardBrand: "visa", cardLastDigits: "1234" } }; }
    return { state: "ready", contracts: [
      b(12, 30, "active", [ sLine("The Long Run — Dark", "Whole bean · 12oz", 1, 35.99, 47.98, true), sLine("Caffyne Pouch", "15 ct", 2, 0, 7.99, true) ]),
      b(26, 45, "paused", [ sLine("Recovery Tea", "20 ct", 1, 18.0, 24.0, true) ]),
      b(-30, 30, "cancelled", [ sLine("Trail Blend", "12oz", 1, 32.0, 42.0, true) ])
    ] };
  }

  if (DESIGN && !window.LRCMP_SUBS) { window.LRCMP_SUBS = sampleData(); window.LRCMP_DATA = window.LRCMP_DATA || {}; }
  if (window.LRCMP_SUBS) onData();
  document.addEventListener("lrc-mp:subscription", onData);
  /* cross-file trigger: member-portal.js fires this after an item write to repaint the card in place (no reload) */
  document.addEventListener("lrc-mp:contract-changed", function () { refreshActivePricing(); });
  document.addEventListener("lrc-mp:identity", function () { if (subsContracts().length) renderActive(activeIndex()); });
  document.addEventListener("lrc-mp:sub-active", function (e) { renderActive(e && e.detail ? e.detail.index : activeIndex()); });
  /* winback locked-tile flag flipped (set/updated/cleared) -> repaint the active card so the tile reflects it */
  document.addEventListener("lrc-mp:winback-pending", function () { if (subsContracts().length) renderActive(activeIndex()); });
  /* engine published its results -> repaint only the forecast region for the active (non-paused/ended) contract */
  document.addEventListener("lrc:forecast-ready", function () {
    var contracts = subsContracts(); if (!contracts.length) return;
    /* re-render tabs (engine ship date in "Ships {date}") and the active card (header hero/subline + timeline) */
    renderSelector(contracts);
    renderActive(activeIndex());
  });
  wirePromo();   /* promo box is static markup → wire its handlers once */
  /* dismiss the locked-cadence popover on any click outside it (the picker's own handler stops propagation) */
  document.addEventListener("click", function (e) {
    var p = root.querySelector("[data-cadence-locked]"); if (!p || p.hidden) return;
    if (!p.contains(e.target)) p.hidden = true;
  });
})();
